export const certificateMain = [
  {
    name: 'certificate',
    path: '/certificate',
    meta: {
      title: '证书管理',
      icon: 'shezhi',
      plugin: 'certificate'
    }
  },
  {
    path: '/certificate/template',
    name: 'certificateTemplate',
    component: () => import('/@/views/plugins/certificate/Template/List.vue'),
    meta: {
      title: '证书模板',
      plugin: 'certificate'
    }
  },
  {
    path: '/certificate/template/design',
    name: 'templateDesign',
    component: () => import('/@/views/plugins/certificate/Template/Design.vue'),
    meta: {
      title: '模板设计',
      plugin: 'certificate'
    }
  },
  {
    path: '/certificate/list',
    name: 'certificateList',
    component: () => import('/@/views/plugins/certificate/List.vue'),
    meta: {
      title: '证书列表',
      plugin: 'certificate',
      keepAlive: true
    }
  }
]

export default certificateMain

